module.exports = __webpack_public_path__ + "static/img/2-2.f458418.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/2-2.png
// module id = Mhue
// module chunks = 0